// extracted by mini-css-extract-plugin
export default {"top":"Clients_top__n4GtQ","box":"Clients_box__Auabc","addButton":"Clients_addButton__MalXb"};